/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Expires_AtInputs */

const en_settings_credits_expires_at = /** @type {(inputs: Settings_Credits_Expires_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires`)
};

/**
* | output |
* | --- |
* | "Expires" |
*
* @param {Settings_Credits_Expires_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_expires_at = /** @type {((inputs?: Settings_Credits_Expires_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Expires_AtInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_expires_at(inputs)
});
export { settings_credits_expires_at as "settings.credits.expires_at" }